import type {
  AbgleichZeile,
  MitarbeiterFelder,
} from './entities/Mitarbeiterabgleich';

// Ein bereits in e2n existierender Standort wird nie durch DATEV überschrieben.
export function ermittleZielStandort(zeile: AbgleichZeile): string | null {
  return zeile.e2n?.standort ?? zeile.datev?.standort ?? null;
}

export function istUebernehmbar(zeile: AbgleichZeile): boolean {
  return zeile.datev !== null;
}

export function teileAuswahl(
  zeilen: AbgleichZeile[],
  selectedIds: Set<string>,
): { mitStandort: AbgleichZeile[]; ohneStandort: AbgleichZeile[] } {
  const ausgewaehlt = zeilen.filter(
    (zeile) => selectedIds.has(zeile.id) && istUebernehmbar(zeile),
  );

  return {
    mitStandort: ausgewaehlt.filter((z) => ermittleZielStandort(z) !== null),
    ohneStandort: ausgewaehlt.filter((z) => ermittleZielStandort(z) === null),
  };
}

// Setzt den im Dialog gewählten Standort als DATEV-Standort, damit
// ermittleZielStandort ihn bei der Übernahme verwendet.
export function ordneStandorteZu(
  zeilen: AbgleichZeile[],
  zuordnung: Record<string, string>,
): AbgleichZeile[] {
  return zeilen.map((zeile) => {
    const standort = zuordnung[zeile.id];
    if (!standort || !zeile.datev) {
      return zeile;
    }
    return { ...zeile, datev: { ...zeile.datev, standort } };
  });
}

export function ermittleStandorte(mitarbeiter: MitarbeiterFelder[]): string[] {
  return [
    ...new Set(
      mitarbeiter.flatMap((m) => (m.standort === null ? [] : [m.standort])),
    ),
  ].sort((a, b) => a.localeCompare(b, 'de', { numeric: true }));
}

export function uebernehmeMitarbeiter(
  e2nMitarbeiter: MitarbeiterFelder[],
  zeilen: AbgleichZeile[],
): MitarbeiterFelder[] {
  const byNr = new Map(e2nMitarbeiter.map((m) => [m.personalnr, m]));

  zeilen.forEach((zeile) => {
    if (!zeile.datev) {
      return;
    }
    byNr.set(zeile.datev.personalnr, {
      ...zeile.datev,
      standort: ermittleZielStandort(zeile),
    });
  });

  return [...byNr.values()];
}
